import { useRootLoader } from '#app/utils/use-root-loader.js'

const Page = () => {
	const {
		requestInfo: { origin },
	} = useRootLoader()
	return (
		<main className="container mx-auto p-4">
			<h1>
				INFORMACE O ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ (OÚ) Správce OÚ: dompe selvafin
				s.r.o., IČ
			</h1>
			<h2>
				29397138 se sídlem náměstí Jurije Gagarina 1230/3, Slezská Ostrava, 710
				00 Ostravazapsaný ve veřejném rejstříku vedeném Krajským soudem v
				Ostravě, oddíle C, vložce 27295
			</h2>
			<p>1. Úvod</p>
			<p>
				1.1. Tento dokument vyhotovil správce OÚ za účelem splnění povinností
				informovat subjekty údajů o okolnostech zpracování v rámci plnění
				smluvních povinností, propagace a přímého marketingu správce OÚ ve
				smyslu čl. 13 a 14 Nařízení Evropského parlamentu a Rady (EU) č.
				2016/679 o ochraně fyzických osob v souvislosti se zpracováním osobních
				údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (tzv.
				obecného nařízení o ochraně osobních údajů, dále jen 'Nařízení').
			</p>
			<p>2. Zpracování osobních údajů z důvodu plnění smluvní povinnosti</p>
			<p>
				2.1. Správce OÚ je oprávněn zpracovávat osobní údaje subjektu údajů
				(objednatele) v rozsahu jeho identifikačních a adresních údajů pro účely
				uzavření smlouvy o dílo, jejíž předmětem je zhotovení hráčských karet a
				pro účely plnění této smluv.
			</p>
			<p>
				2.2. Správce OÚ je dále oprávněn zpracovávat osobní údaje subjektu údajů
				(hráče) v rozsahu jeho identifikačních a adresních údajů, fotografie,
				přezdívky, čísla dresu, sezóny, výšky, oddílu, sportovní třídy a postu
				ve hře pro účely plnění smlouvy o dílo, jejíž předmětem je zhotovení
				hráčských karet.
			</p>
			<p>
				2.3. Zpracování osobních údajů dle tohoto čl. 3 je správce OÚ oprávněn
				provádět za účelem uzavření předmětné smlouvy a jejího následného
				plnění, přičemž doba zpracování je omezena dobou trvání smlouvy,
				případně dobou nezbytnou pro vyřešení nároků kterékoli strany
				vyplývajících ze smlouvy, pokud po ukončení smlouvy takové nároky
				přetrvávají.
			</p>
			<p>
				2.4. Poskytnutí osobních údajů pro účel dle tohoto článku správci OÚ je
				pro subjekt údajů povinné, přičemž bez tohoto poskytnutí s ním správce
				OÚ nemůže řádně uzavřít předmětnou smlouvu a plnit povinnosti a
				uplatňovat práva z ní vyplývající.
			</p>
			<p>3. Zpracování osobních údajů na základě souhlasu subjektu údajů</p>
			<p>
				3.1. Uzavřením smlouvy o dílo a odsouhlasením tohoto dokumentu o
				zpracování osobních údajů uděluje subjekt údajů souhlas se zpracováním
				jeho osobních údajů v následujícím rozsahu a k následujícím účelům:
			</p>
			<p>
				3.1.1. použití správcem OÚ pořízených nebo subjektem údajů dodaných
				fotografií, identifikačních a adresních údajů, přezdívky, čísla dresu,
				sezóny, výšky, oddílu, sportovní třídy a postu ve hře subjektu údajů
				(hráče) pro účely propagace správce OÚ a jeho produktů zejména na
				webových stránkách správce OÚ.
			</p>
			<p>
				3.2. Osobní údaj dle tohoto čl. 3 je získán od samotného subjektů údajů,
				v případě dětí mladších 16 let od osob vykonávajících rodičovskou
				odpovědnost k dítěti. Správce OÚ je oprávněn osobní údaj dle tohoto
				článku zpřístupňovat třetím osobám pouze z důvodu naplnění účelů
				uvedených v čl. 3.1.1.
			</p>
			<p>
				3.3. Souhlas dle tohoto článku je udělen na dobu 3 let od odsouhlasení
				tohoto dokumentu. Subjekt OÚ je nicméně oprávněn souhlas kdykoliv
				odvolat písemným sdělením zaslaném správci OÚ na e-mailovou adresu
				info@hracskekarty.cz.
			</p>
			<p>
				Odvoláním souhlasu není dotčena zákonnost zpracování osobních údajů do
				okamžiku odvolání. Neudělení nebo odvolání souhlasu nemá žádný vliv na
				práva a povinnosti subjektu OÚ a správce OÚ vzniklá ze smlouvy o dílo.
			</p>
			<p>
				4. Zpracování osobních údajů na základě oprávněných zájmů správce OÚ
			</p>
			<p>
				4.1. Správce OÚ je oprávněn pro účely svých oprávněných zájmů či zájmů
				třetí strany zpracovávat osobní údaje subjektu údajů (objednatele) v
				následujícím rozsahu a k následujícím účelům:
			</p>
			<p>
				4.1.1. e-mailovou adresu subjektu údajů pro účely zasílání obchodních
				sdělení týkajících se produktů a služeb poskytovaných správcem OÚ,
			</p>
			<p>
				4.1.2. jméno a příjmení, e-mailovou adresu subjektu údajů pro účely
				přímého marketingu.
			</p>
			<p>
				4.2. Právním základem zpracování osobních údajů dle předchozího článku
				je výkon oprávněného zájmu správce OÚ spočívajícího v přímém nabízení
				služeb subjektu údajů a v získávání zpětné vazby subjektu údajů.
			</p>
			<p>
				4.3. Správce OÚ je oprávněn zpracovávat osobní údaje dle tohoto článku
				do vznesení námitky subjektu údajů proti zpracování jeho osobních údajů
				dle čl. 6.5.
			</p>
			<p>5. Informace o podmínkách zpracování osobních údajů správcem OÚ</p>
			<p>
				5.1. Správce OÚ je oprávněn zpracovávat osobní údaje subjektu údajů
				manuálně nebo automatizovaně prostřednictvím vlastních zaměstnanců.
				Osobní údaje budou zpracovávány ve formě zabezpečených databází.
			</p>
			<p>
				5.2. Správce OÚ zabezpečuje zpracovávané osobní údaje pomocí
				organizačních, fyzických a softwarových prostředků zabezpečení, zejména
				prostřednictvím nastavení přístupových práv zaměstnanců k příslušným
				informačním systémům, fyzickým zabezpečením prostor správce OÚ a
				datových nosičů a prostředky softwarové ochrany před neoprávněným
				přístupem k datům prostřednictvím sítě internet. Zásady obecné datové a
				informační bezpečnosti stanoví správce OÚ samostatným dokumentem.
			</p>
			<p>
				5.3. Správce OÚ nepoužívá osobní údaje subjektu údajů k rozhodování
				založeném výhradně na automatizovaném zpracování, včetně profilování.
			</p>
			<p>
				5.4. Správce OÚ nepředává osobní údaje subjektu údajů žádnému jinému
				subjektu jak v rámci EU, tak i třetích zemí mimo EU.
			</p>
			<p>
				6. Informace o právech subjektu údajů v rámci zpracování osobních údajů
			</p>
			<p>
				6.1. Subjekt údajů má právo požadovat na správci OÚ, aby mu poskytl
				přístup k jeho osobním údajům ve formě výpisu všech zpracovávaných
				osobních údajů ve vztahu k jednotlivým účelům zpracování. Subjekt údajů
				je rovněž oprávněn požadovat informaci o zpracovatelích,
				zpracovávajících na základě dohody se správcem OÚ jeho osobní údaje.
			</p>
			<p>
				6.2. V případě, že se subjekt údajů domnívá, že správce OÚ jeho osobní
				údaje zpracovává v rozporu s tímto dokumentem nebo s právními předpisy,
				je oprávněn na správci požadovat vysvětlení a sjednání nápravy.
				Zpracovává-li správce nepřesné osobní údaje subjektu údajů, je subjekt
				údajů oprávněn požadovat jejich opravu.
			</p>
			<p>
				6.3. Subjekt údajů je oprávněn požadovat na správci OÚ výmaz jeho
				osobních údajů, pokud tyto osobní údaje přestaly být potřebné pro
				vymezené účely zpracování, subjekt údajů odvolal svůj souhlas se
				zpracováním osobních údajů a pro toto zpracování neexistuje žádný jiný
				důvod, anebo kdy subjekt údajů vznesl námitky proti zpracování osobních
				údajů a neexistují žádné převažující důvody pro zpracování.
			</p>
			<p>
				6.4. Subjekt údajů je oprávněn požadovat na správci OÚ omezení
				zpracování osobních údajů v případě, kdy subjekt údajů popírá přesnost
				zpracovávaných osobních údajů, a to na dobu potřebnou k tomu, aby
				správce OÚ mohl přesnost zpracovávaných údajů ověřit, nebo je zpracování
				osobních údajů dle subjektů údajů protiprávní a tento odmítá provedení
				výmazu osobních údajů, nebo správce OÚ osobní údaje nepotřebuje pro
				stanovené účely zpracování, ale subjekt údajů je požaduje pro určení,
				výkon nebo obhajobu právních nároků.
			</p>
			<p>
				6.5. Subjekt údajů je oprávněn vznést námitku proti zpracování jeho
				osobních údajů, zpracovávaných na základě oprávněných zájmů správce OÚ
				či třetí strany dle čl. 4, pokud zároveň uvede důvody, týkající se jeho
				konkrétní situace. Správce OÚ je na základě námitky povinen zpracování
				údajů ukončit, ledaže prokáže, že důvod zpracování spočívající v ochraně
				jeho zájmů převažuje nad zájmy a svobodami subjektu údajů.
			</p>
			<p>
				6.6. V případě podezření, že správce OÚ zpracovává osobní údaje subjektu
				údajů v rozporu s právními předpisy nebo tímto dokumentem nebo
				nevyhoví-li správce OÚ některému z výše uvedených požadavků subjektu
				údajů, j e subjekt údajů oprávněn podat stížnost dozorovému orgánu,
				kterým je Úřad pro ochranu osobních údajů (www.uoou.cz).
			</p>
			<p>7. Závěrečná ustanovení</p>
			<p>
				7.1. V případě, že správce OÚ začne se zpracováváním osobních údajů
				poskytnutých subjektem údajů k jiným účelům, než které vyplývají z
				tohoto dokumentu, neprodleně o této skutečnosti informuje příslušné
				subjekty údajů, informuje je o jednotlivých aspektech zpracování a v
				případě, že je ke zpracování k tomuto účelu vyžadován souhlas subjektu
				údajů, o tento souhlas před započetím zpracování subjekt údajů požádá. V
				případě, že subjektu údajů souhlas neudělí, není správce OÚ oprávněn s
				dalším zpracováním osobních údajů začít, není-li dán jiný právní základ
				zpracování.
			</p>
			<p>
				7.2. Tento dokument je subjektu údajů poskytnut v elektronické podobě
				před odesláním objednávky hráčských karet a následně také webových
				stránkách správce OÚ, kde je pod následujícím odkazem {origin}
				/privacy-policy nepřetržitě dostupný všem subjektům údajů.
			</p>
		</main>
	)
}

export default Page
